var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signPayReturn"},[_c('el-result',{attrs:{"icon":"success","title":"支付成功"}},[_c('template',{slot:"extra"})],2),_c('span',{staticClass:"title"},[_vm._v("请到OTE-A官网查看支付结果")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }